
  document.addEventListener("DOMContentLoaded", () => {
    const variantData = [...document.querySelectorAll(".variant-data .varnt")];
    const flavorSwatches = document.querySelectorAll(".flavour_swatches li, .first_swatch_option");
    const bagSelect = document.querySelector('select[data-option="Bag"]');
    const deliverySelect = document.querySelector('select[data-option="Delivery Frequency"]');
    const addButton = document.querySelector(".custom-add");
    const sellingInput = document.querySelector('.sell_opt .selling-update');
    const selectDelivery = deliverySelect;
    let selectedFlavor = document.querySelector(".flavour_swatches .active_swatch")?.dataset.name || "";
    const sellingPlans = {};
    document.querySelectorAll('.sell_opt .selling-plan-option label').forEach(label => {
      sellingPlans[label.textContent.trim().toLowerCase()] =
        label.getAttribute('data-value').toLowerCase();
    });



    function getVariant() {
      let parts = [];
      if (selectedFlavor) parts.push(selectedFlavor);
      if (bagSelect && bagSelect.value) parts.push(bagSelect.value);
      if (deliverySelect && deliverySelect.value) parts.push(deliverySelect.value);
      const title = parts.join(" / ");
      const v = variantData.find(el => el.dataset.variantTitle === title);
      if (!v) {
        return null;
      }
      return {
        id: v.dataset.varId,
        price: v.dataset.varnPrice,
        comprice: v.dataset.varnComprice
      };
    }

    function updateVariant() {
      const variant = getVariant();
      if (!variant) return;
      addButton.dataset.variantId = variant.id;
      addButton.id = variant.id;
      console.log("Variant ID:", variant.id);
      $(".variants_selected_data li").hide();
      const item = $(`.variants_selected_data li[data-id='${variant.id}']`).show();
      $('.free_gifts_container').toggle(item.length > 0);
      updateSellingPlan();
    }

    function updateSellingPlan() {
      if(sellingInput){
        const selected = selectDelivery.value.trim().toLowerCase();
        const planId = sellingPlans[selected] || "";
        const variant = getVariant();
        console.log(sellingInput,'sellingNott');
        addButton.dataset.selling = planId;
        if (sellingInput) sellingInput.value = planId;
        let selling = JSON.parse($('.selling_plans_json').html());
        let plan = selling?.[0]?.selling_plans?.find(e => e.id == planId);
        let percentage = plan?.price_adjustments?.[0]?.value || 0;
        let price = Number(variant.price);
        let compAtprice = Number(variant.comprice);
        let dis = price - (price * percentage / 100);
        let discountPrice = dis.toFixed(2)/100
        let orignalPrice = price / 100;
        let comPrice = compAtprice / 100;

        if (discountPrice > comPrice) {
          if(discountPrice.toFixed(2)===orignalPrice.toFixed(2)){
            $('span.main_Price').html(`$${discountPrice.toFixed(2)}`);
            $('.main_compPrice').html(``);       
          }else{
            $('span.main_Price').html(`$${discountPrice.toFixed(2)}`);
            $('.main_compPrice').html(`$${orignalPrice.toFixed(2)}`);
          }    
        } else { 
            if ($('span.main_Price').hasClass('free-product')) {
                $('span.main_Price').html(`$0.00`);
            } else {
                $('span.main_Price').html(`$${discountPrice.toFixed(2)}`);
            }
          $('.main_compPrice').html(`$${comPrice.toFixed(2)}`);
        }
      }
    
      if ($('span.main_Price').hasClass('free-product')) {
        $('span.main_Price').html(`$0.00`);
      }
      if('body.super-greens-new' && deliverySelect.value==='One Time'){
        $('span.main_compPrice').html($('span.main_Price').attr('data-secvar-price'));
      }else{
        if ($('span.main_compPrice').hasClass('free-product-compare')) {
          $('span.main_compPrice').html($('span.main_Price').attr('data-discounted-price'));
        }
      }
      
      if(sellingInput.value){
      $('.main_compPrice.free-product-compare').addClass('line-through').addClass('ml-5')
      $('.main_Price.free-product').css('display', 'inline-block');
      }else{
      $('.main_compPrice.free-product-compare').removeClass('line-through').removeClass('ml-5')
      $('.main_Price.free-product').css('display', 'none');
      }
            
            
    }

    flavorSwatches.forEach(swatch => {
      swatch.addEventListener("click", () => {
        selectedFlavor = swatch.dataset.name;
        updateVariant();
      });
    });

    bagSelect.addEventListener("change", updateVariant);
    deliverySelect.addEventListener("change", updateVariant);
    updateVariant();
  });

  $('.custom-add').on('click', async function(e) {
    e.preventDefault();
    $(this).addClass('active')
    var variantId  = parseInt($(this).attr('id'));
    let random = Math.floor(Math.random() * 1000);
    var sellingPlan = parseInt($(this).attr('data-selling'));
    var qtyInput = $(this).closest('.product-formMain__option, form').find('input[name="quantity"]');
    var qty = parseInt(qtyInput.val()) || 1;
    var jsonString = $('.free_gifts_json').attr('data-metafield');
    var data = JSON.parse(jsonString);
    var result = data?.variants?.filter(function(e) { return e.id === variantId });
    var gifts = result[0].free_gifts;
    var items = [];
    gifts?.forEach(function(giftId) {
      items.push({
        quantity: qty,
        id: giftId.id,
        properties: { __Free_gift: random, Free_gift: 'free' }
      });
    });
    if($('body').hasClass('transformation-body-protein')){
      items.push({
        quantity: qty,
        id: variantId,
        selling_plan: sellingPlan,
        properties: { __Free_gift: random }
      });
    }
    else{
      items.push({
        quantity: qty,
        id: variantId,
        selling_plan: sellingPlan,
        properties: { __Free_gift: random }
      });
    }
    console.log("Final Items:", items);
    if(!$('body').hasClass('page-7-reasons-limited-time-offer')){
      if($('body').hasClass('transformation-protein-newdesign') || $('body').hasClass('7-reasons-exclusive-offer')) {  
        await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                items: items
            })
        });
        window.location.href = '/checkout';
      }
      else{
        await window.miniCart.addToCart(items);
      }
    }
    else{
      await window.miniCart.addToCart(items);
    }
    $(this).removeClass('active')
  });

  async function updatequantity(val,qty) {
    try {
      const cart = await window.miniCart.getCart();
      const giftItems = cart.items.filter(item =>
        item.properties && item.properties.__Free_gift  == val
      );
      let updates = {};
      giftItems.forEach(item => {
        updates[item.key] = qty;
      });
      if (Object.keys(updates).length === 0) return;
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      await window.miniCart.getCart()
      $('.mini-cart__body').removeClass('active')
      if (window.location.pathname === '/cart') {
          window.location.href = '/cart';
      }
    } 
    catch (err) {
      console.error('Error removing gifts:', err);
    }
  }

  async function removeFreeGifts(val) {
    try {
        console.log(val,'val')
      const cart = await window.miniCart.getCart();
      const giftItems = cart.items.filter(item =>
        item.properties && item.properties.__Free_gift  == val
      );
      let updates = {};
      giftItems.forEach(item => {
        updates[item.key] = 0;
      });
      console.log(giftItems,'giftItems')
      if (Object.keys(updates).length === 0) return;
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      console.log('Free gifts removed');
      
      await window.miniCart.getCart()
      $('.mini-cart__body').removeClass('active')
    if (window.location.pathname === '/cart') {
        window.location.href = '/cart';
    }
    } catch (err) {
      console.error('Error removing gifts:', err);
    }
  }

  $(document).on('click', '.Custom_remove_function', async function(e) {
    e.preventDefault();
    let free = parseInt($(this).parents('.cart_qtyPrice__wrapper').attr('data-free-gift'))
    await removeFreeGifts(free);
  });

  $(document).on('click', '.custom_remove button.mini-cart__body-line-item-decrease', async function(e) {
    e.preventDefault();
    e.stopPropagation() 
    $('.mini-cart__body').addClass('active') 
    let free = parseInt($(this).attr('data-free-gift'))
    await removeFreeGifts(free);
  });
  
  $(document).on('click', '.Custom_add_function', async function(e) {
    e.preventDefault();
    $('.mini-cart__body').addClass('active')
    let free = parseInt($(this).parents('.cart_qtyPrice__wrapper').attr('data-free-gift'))
    let qty = $(this).parents('.qty_wrapper').find('input[name="quantity"]').val()
    await updatequantity(free,qty);
  });

  $(document).on('click', '.Mini_Custom_add_function', async function(e) {
    e.preventDefault();
    $('.mini-cart__body').addClass('active')
    let free = parseInt($(this).parents('.maincart_qtyPrice__wrapper').attr('data-free-gift'))
    let qty = parseInt($(this).parents('.maincart_qtyPrice__wrapper').attr('data-qty')) + 1
    await updatequantity(free,qty);
  });

  $(document).on('click', '.Mini_Custom_remove_function', async function(e) {
    e.preventDefault();
    $('.mini-cart__body').addClass('active')
    let free = parseInt($(this).parents('.maincart_qtyPrice__wrapper').attr('data-free-gift'))
    let qty = parseInt($(this).parents('.maincart_qtyPrice__wrapper').attr('data-qty')) - 1
    await updatequantity(free,qty);
  });

  
  
  $(document).on('click', '.Cart_drawer[data-action="open-drawer"]', async function(e) {
    e.preventDefault();
    window.miniCart.openMiniCart()
  });

  $(document).on('click', '.subscrive_and_save', function (e) {
    e.preventDefault();
    $(this).addClass('active').siblings().removeClass('active');
    let sell_id = $(this).attr('data-id');
    let sell_name = $(this).attr('data-name');
    let price;
    if($('body').hasClass('transformation-protein-newdesign') || $('body').hasClass('7-reasons-exclusive-offer')) {  
      price = $(this).find('.After_selling_discount').attr('data-main-price');
    }
    else{
      price = $(this).find('.After_selling_discount').text(); 
    }
    let first = $(this).attr('data-name').replace(/\b\w/g, char => char.toUpperCase());
    let sec = $('.product-formMain__variants .custom_flavour_swatches li.active_swatch').attr('data-name');
    let var_data = JSON.parse($('.variants_data').text());
    console.log(var_data);
    let variant;
    if($('body').hasClass('transformation-body-protein') || $('body').hasClass('page-7-reasons-limited-time-offer') || $('body').hasClass('first-order')){
      if(sell_name == "Every 4 Weeks"){
        console.log(`${sec} / ${first}`)
        variant = var_data?.find(item => item.title === `${sec} / ${first}`);
      }
      else{
        console.log('One time',`${sec} / ${first}`)
        variant = var_data?.find(item => item.title === `${sec} / ${first}`);
      }
    }

    else if($('body').hasClass('transformation-protein-newdesign') || $('body').hasClass('template-page-7-reasons-exclusive-offer')) {  
      if(sell_name == "Every 12 Weeks"){
        console.log(`${sec} / 3 Bags / ${first}`)
        variant = var_data?.find(item => item.title === `${sec} / 3 Bags / ${first}`);
        $('.pdp-logos.Custom_section .Custom_texttt').text("Renews $147 at 30% off every 12 weeks unless canceled");
        $('.swiper-pagination .swiper-pagination-bullet:nth-child(1)').click();
      }
      else{
        console.log(`${sec} / 1 Bag / ${first}`)
        variant = var_data?.find(item => item.title === `${sec} / 1 Bag / ${first}`);
        $('.pdp-logos.Custom_section .Custom_texttt').text("Renews $59 at 15% off every 4 weeks unless canceled");
        $('.swiper-pagination .swiper-pagination-bullet:nth-child(2)').click();
      }
    }

    else{
      console.log(`${sec} / 1 Bag / ${first}`)
      variant = var_data?.find(item => item.title === `${sec} / 1 Bag / ${first}`);
    }
    if(variant)$('.custom-add-newdesign').attr('id',variant.id).attr('data-selling',sell_id)
    console.log(variant,'variant')
    $('.custom-add-newdesign span').text(` ${price}`)
  });

  document.querySelectorAll('.product-accordion .accordion-header').forEach(button=>{
    button.addEventListener('click',()=>{
      const item=button.parentElement;
      const content=item.querySelector('.accordion-content');
      if(item.classList.contains('active')){
        item.classList.remove('active');
        content.style.maxHeight=null;
      }else{
        item.classList.add('active');
        content.style.maxHeight=content.scrollHeight+'px';
      }
    });
  });

  $('.Same_design.One_time .pvo-input-container').on('click', async function(e) {
      e.preventDefault();
      $(this).addClass('active');

      let sec = $(this).parents('.ProductForm').find('.active_swatch').attr('data-name');
      let first = 'One Time';
      let var_data = JSON.parse($('.variants_data').text());
      console.log(var_data);
      let variant;
      if($('body').hasClass('transformation-protein-newdesign') || $('body').hasClass('template-page-7-reasons-exclusive-offer')) {  
          console.log(`${sec} / 1 Bag / ${first}`)
          variant = var_data?.find(item => item.title === `${sec} / 1 Bag / ${first}`);
      }
      else{
        console.log(`${sec} / 1 Bag / ${first}`)
        let variant = var_data?.find(item => item.title === `${sec} / 1 Bag / ${first}`);
      }
      if(variant)$('.custom-add-newdesign').attr('id',variant.id);
      console.log(variant,'variant11')
      
      var variantId;
      if($('body').hasClass('transformation-protein-newdesign') || $('body').hasClass('template-page-7-reasons-exclusive-offer')) {  
        variantId  = parseInt(variant.id);
      }
      else{
        variantId  = parseInt($('.custom-add-newdesign').attr('id'));
      }
      let random = Math.floor(Math.random() * 1000);
      var qtyInput = $(this).closest('.product-formMain__option, form').find('input[name="quantity"]');
      var qty = parseInt(qtyInput.val()) || 1;
      var jsonString = $('.free_gifts_json').attr('data-metafield');
      var data = JSON.parse(jsonString);
      var result = data?.variants?.filter(function(e) { return e.id === variantId });
      var gifts = result[0].free_gifts;
      var items = []
      gifts?.forEach(function(giftId) {
        items.push({
          quantity: qty,
          id: giftId.id,
          properties: { __Free_gift: random, Free_gift: 'free' }
        });
      });
      items.push({
        quantity: qty,
        id: variantId,
      });
      console.log("Final Itemsss:", items);
      
        if($('body').hasClass('transformation-protein-newdesign') || $('body').hasClass('7-reasons-exclusive-offer')) {  
          await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
              },
              body: JSON.stringify({
                  items: items
              })
          });
          window.location.href = '/checkout';
        }
        else{
          await window.miniCart.addToCart(items);
        }
      
      $(this).removeClass('active')
  });

  $(document).ready(function () {
    if($('body').hasClass('transformation-body-protein') || $('body').hasClass('page-7-reasons-limited-time-offer') || $('body').hasClass('first-order')){
      $('.subscrive_and_save').eq(0).click();
    }
    else{  
      $('.subscrive_and_save').eq(1).click();
    }  
  });

  $(document).ready(function(){
    if($('body').hasClass('transformation-protein-newdesign') ||  $('body').hasClass("7-reasons-exclusive-offer")) {
        if ($('body').hasClass('page-7-reasons-limited-time-offer')) {
            return
        }
        $('.subscription-widegt .subscrive_and_save[data-name="Every 12 Weeks"] span.Simple_price.After_selling_discount').html('$33');
        $('.subscription-widegt .subscrive_and_save[data-name="Every 12 Weeks"] span.Simple_price.After_selling_discount').attr('data-main-price', '$99');
        $('.subscription-widegt .subscrive_and_save[data-name="Every 12 Weeks"] span.Simple_price.cross').html('$69.95');
        $('.subscription-widegt .subscrive_and_save[data-name="Every 4 Weeks"] span.Simple_price.After_selling_discount').html('$49');
        $('.subscription-widegt .subscrive_and_save[data-name="Every 4 Weeks"] span.Simple_price.After_selling_discount').attr('data-main-price', '$49');
        $('.subscription-widegt .subscrive_and_save[data-name="Every 4 Weeks"] span.Simple_price.cross').html('$69.95');
        $('.Same_design.One_time .Price_container span.Simple_price.After_selling_discount').html('$69.95');

        setTimeout(function(){
            var price_custom = $('body .subscrive_and_save.active span.Simple_price.After_selling_discount').attr('data-main-price');
            $('body .custom-add.custom-add-newdesign span').html(price_custom);
        },100)
    }
  })

  $(document).ready(function () {
    var $mainProduct = $('.transformation-protein-newdesign .main-product');
    var $cartBar = $('.transformation-protein-newdesign .cart-bar');

    if (!$mainProduct.length || !$cartBar.length) return;

    $(window).on('scroll', function () {
      var mainProductBottom =
        $mainProduct.offset().top + $mainProduct.outerHeight();

      if ($(window).scrollTop() >= mainProductBottom) {
        $cartBar.addClass('is-visible');
      } else {
        $cartBar.removeClass('is-visible');
      }
    });
  });

  $('.transformation-protein-newdesign .product__cart-bar-notification-button').on('click', function () {
    $('html, body').animate(
      {
        scrollTop: $('.ProductForm').offset().top
      },
      10
    );
  });

  $(document).on('click', 'body.template-page-7-reasons-exclusive-offer a.ButtonGroup__Item.buy-now-scroll', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $productForm = $($(this).attr('href'));

    if ($productForm.length) {
      $('html, body').animate({
        scrollTop: $productForm.offset().top - 60
      }, 100);
    }
  });

  /**********************/
  $(document).ready(function () {
    if ($('body').hasClass('transformation-protein') || $('body').hasClass('transformation-protein-2')) {
      var select = $('select[data-option="Delivery Frequency"]');
      var button = $('.custom-add');
      function getValue() {
        var value = select.val()
          .toLowerCase()
          .replace(/\bdelivery\b|\bdeliver\b/g, '')
          .trim();
        var matchedLabel = $('.selling-plan-option label').filter(function () {
          var name = $(this).attr('data-name')
            .toLowerCase()
            .replace(/\bdelivery\b|\bdeliver\b/g, '')
            .trim();
          return name === value;
        }).first();
        var dataValue = matchedLabel.attr('data-value');
        console.log(dataValue, 'dataValue');
        button.attr('data-selling', dataValue || '');
      }

      getValue();
      select.on('change', getValue);

      button.each(function () {
        var target = this;
        var observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (
              mutation.type === 'attributes' &&
              mutation.attributeName === 'data-variant-id'
            ) {
              console.log(
                'data-variant-id changed:',
                $(target).attr('data-variant-id')
              );
              getValue();
            }
          });
        });
        observer.observe(target, {
          attributes: true,
          attributeFilter: ['data-variant-id']
        });
      });
    }
  });